module.exports = __webpack_public_path__ + "static/media/IS.b419767d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/IS.svg
// module id = 281
// module chunks = 0